import { useState } from 'react'
import { useVaultStore } from '@/stores/vaultStore'
import Modal from '@/components/ui/Modal'
import { showToast } from '@/components/ui/Toast'
import styles from './VaultPinModal.module.css'

interface Props {
  open?: boolean
  onClose: () => void
}

export default function VaultPinModal({ open = true, onClose }: Props) {
  const { pinConfigured, setupPin, changePin } = useVaultStore()
  const [mode] = useState<'setup' | 'change'>(pinConfigured ? 'change' : 'setup')
  const [loginPwd, setLoginPwd] = useState('')
  const [pin1, setPin1] = useState('')
  const [pin2, setPin2] = useState('')
  const [oldPin, setOldPin] = useState('')
  const [error, setError] = useState('')

  const handleSetup = async () => {
    if (!loginPwd) { setError('请输入登录密码'); return }
    if (pin1.length < 4 || pin1.length > 6) { setError('私密密码需要4-6位数字'); return }
    if (!/^[0-9]+$/.test(pin1)) { setError('私密密码仅限数字'); return }
    if (pin1 !== pin2) { setError('两次输入不一致'); return }
    const err = await setupPin(pin1, loginPwd)
    if (err) { setError(err); return }
    showToast('私密密码已设置')
    onClose()
  }

  const handleChange = async () => {
    if (!oldPin || !pin1) { setError('请填写完整'); return }
    if (pin1.length < 4 || pin1.length > 6) { setError('新密码需要4-6位数字'); return }
    if (!/^[0-9]+$/.test(pin1)) { setError('仅限数字'); return }
    if (pin1 !== pin2) { setError('两次输入不一致'); return }
    const err = await changePin(oldPin, pin1)
    if (err) { setError(err); return }
    showToast('密码已修改')
    onClose()
  }

  return (
    <Modal open={open} onClose={onClose} title={mode === 'setup' ? '设置私密密码' : '修改私密密码'}>
      {mode === 'setup' ? (
        <div className={styles.form}>
          <input
            className={styles.input}
            type="password"
            placeholder="登录密码（验证身份）"
            value={loginPwd}
            onChange={e => { setLoginPwd(e.target.value); setError('') }}
          />
          <input
            className={styles.input}
            type="password"
            inputMode="numeric"
            placeholder="4-6位数字私密密码"
            maxLength={6}
            value={pin1}
            onChange={e => { setPin1(e.target.value.replace(/[^0-9]/g, '')); setError('') }}
          />
          <input
            className={styles.input}
            type="password"
            inputMode="numeric"
            placeholder="确认私密密码"
            maxLength={6}
            value={pin2}
            onChange={e => { setPin2(e.target.value.replace(/[^0-9]/g, '')); setError('') }}
          />
          <div className={styles.error}>{error}</div>
          <button className={styles.saveBtn} onClick={handleSetup}>设置</button>
        </div>
      ) : (
        <div className={styles.form}>
          <input
            className={styles.input}
            type="password"
            placeholder="当前私密密码"
            maxLength={6}
            value={oldPin}
            onChange={e => { setOldPin(e.target.value.replace(/[^0-9]/g, '')); setError('') }}
          />
          <input
            className={styles.input}
            type="password"
            inputMode="numeric"
            placeholder="新私密密码（4-6位数字）"
            maxLength={6}
            value={pin1}
            onChange={e => { setPin1(e.target.value.replace(/[^0-9]/g, '')); setError('') }}
          />
          <input
            className={styles.input}
            type="password"
            inputMode="numeric"
            placeholder="确认新密码"
            maxLength={6}
            value={pin2}
            onChange={e => { setPin2(e.target.value.replace(/[^0-9]/g, '')); setError('') }}
          />
          <div className={styles.error}>{error}</div>
          <button className={styles.saveBtn} onClick={handleChange}>修改</button>
        </div>
      )}
    </Modal>
  )
}
